///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/components/validation/bindings"/>
import * as buttonBinding from "Core/Medius.Core.Web/Scripts/Medius/components/validation/button/binding";
import * as groupBinding from "Core/Medius.Core.Web/Scripts/Medius/components/validation/group/binding";

export function registerBindings() {
    buttonBinding.register();
    groupBinding.register();
}